import type { CareerSiteLanguageType } from '@locale/locale-store';

import { TranslationKey } from '..';

/** The name inside a sentence: Icelandic needs the accusative ("virkja íslensku"). */
export const careerLanguageInSentenceMap: {
  [language in CareerSiteLanguageType]: TranslationKey;
} = {
  en: 'language.inSentence.en',
  is: 'language.inSentence.is',
  pl: 'language.inSentence.pl',
  no: 'language.inSentence.no',
  sv: 'language.inSentence.sv',
  fr: 'language.inSentence.fr',
};
